<div
  [ngClass]="{
    active: isActive,
    black: theme == 'BLACK'
  }"
  (click)="toggle($event)"
>
  <span></span>
</div>
